<template>
  <div class="carousel">
    <!-- left button -->
    <button
      @click="onCarouselBtnClick('left')"
      class="carousel__button carousel__button--left"
      :class="{ carousel_hidden_btn: isCarouselNavigationLeftButtonHidden }"
    >
      <img
        class="carousel__button__image"
        src="../../../assets/images/card-button/previous.png"
        alt="previous button"
      />
    </button>
    <div class="carousel__track-nav-container">
      <!-- main panel-->
      <div class="carousel__track-container">
        <ul class="carousel__track">
          <li
            :class="
              currentBlockStartIndex * numOfCards + index === currentSlidIndex
                ? 'carousel-slide current-slide'
                : 'carousel-slide'
            "
            v-for="(product, index) in productsCurrent"
            :key="index"
            ref="carouselCards"
          >
            <Card
              :imageUrl="
                product.PhotoUrl ? product.PhotoUrl : product.DefaultImageUrl
              "
              :cardContent="product.Name"
              :cardValue="product.Price"
              :colorStyle="index === 1 ? '#5D77BC' : ''"
              variant="normal"
            />
          </li>
        </ul>
      </div>

      <!-- navigation panel-->
      <div class="text-center">
        <div class="d-flex justify-content-center" v-if="!cardVisible">
          <b-icon-plus-circle
            class="mt-1"
            @click="toggleCardVisible"
          ></b-icon-plus-circle>
          <p class="pl-1">More</p>
        </div>
        <div v-else class="d-flex justify-content-center">
          <b-icon-patch-minus
            class="mt-1"
            @click="toggleCardVisible"
          ></b-icon-patch-minus>
          <p class="pl-1">Less</p>
        </div>
      </div>
      <b-collapse v-model="cardVisible">
        <div @click="onNavClick" class="carousel__nav row no-gutters">
          <button
            v-for="(product, index) in productsCurrent"
            class="carousel__preview__button col-3"
            :class="{
              current__preview:
                currentBlockStartIndex * numOfCards + index ===
                currentSlidIndex,
            }"
            :key="index"
            :data-giftid="product.ProductID"
          >
            <Card
              :imageUrl="
                product.PhotoUrl ? product.PhotoUrl : product.DefaultImageUrl
              "
              :cardContent="product.Name"
              :cardValue="product.Price"
              :colorStyle="index === 1 ? '#5D77BC' : ''"
              :hideContent="true"
              :contentSize="numOfCards"
            />
          </button>
        </div>
      </b-collapse>
    </div>
    <!-- right button -->
    <button
      @click="onCarouselBtnClick('right')"
      class="carousel__button carousel__button--right"
      :class="{ carousel_hidden_btn: isCarouselNavigationRightButtonHidden }"
    >
      <img
        class="carousel__button__image"
        src="../../../assets/images/card-button/next.png"
        alt="previous button"
      />
    </button>
  </div>
</template>

<script>
import { $$, querySelector } from "./../../../sharedscripts/OO_jquery";
import Card from "./Card.vue";

export default {
  name: "CustomCarousel",
  components: {
    Card,
  },
  props: {
    selectedCardValue: {
      required: true,
      type: Number,
    },
    storemenu: {
      type: Object,
      default: () => {},
    },
    selectedGiftCardId: {
      type: Number,
      default: null,
    },
    cardVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "../",
      track: null,
      slides: null,
      previewNav: null,
      previews: null,
      slideWidth: null,
      baseLeft: null,
      leftButton: null,
      rightButton: null,
      numOfCards: 50,
    };
  },
  computed: {
    validProducts: {
      get() {
        return this.$store.getters["newGiftShoppingCart/storeGiftCards"];
      },
    },
    currentSlidIndex() {
      if (this.selectedGiftCardId == null) {
        return 0;
      } else {
        var result = this.validProducts.findIndex((element) => {
          return element.ProductID == this.selectedGiftCardId;
        });
        return result;
      }
    },
    currentBlockIndex() {
      return this.currentSlidIndex % this.numOfCards;
    },
    currentBlockStartIndex() {
      return Math.floor(this.currentSlidIndex / this.numOfCards);
    },
    productsCurrent() {
      const numShown = this.numOfCards;
      const blocksCurrent = [];

      if (this.validProducts.length == 0) return blocksCurrent;

      if (this.validProducts.length <= this.numOfCards) {
        return this.validProducts;
      }

      for (let i = 0; i < numShown; i++) {
        const index = this.currentBlockStartIndex * this.numOfCards + i;
        if (this.validProducts[index] != undefined)
          blocksCurrent.push(this.validProducts[index]);
      }
      return blocksCurrent;
    },
    isCarouselNavigationLeftButtonHidden() {
      return this.currentBlockIndex == 0;
    },
    isCarouselNavigationRightButtonHidden() {
      return this.currentBlockIndex == this.productsCurrent.length - 1;
    },
  },
  mounted() {
    if (this.validProducts.length != 0) {
      this.numOfCards = this.validProducts.length;
      var that = this;
      this.$nextTick(() => {
        that.sliderSetup();
      });
    }
  },
  watch: {
    selectedGiftCardId() {
      if (this.selectedGiftCardId) {
        this.populateselected();
      }
    },
    "$store.state.newGiftShoppingCart.storeGiftCards": {
      handler: function () {
        if (
          this.$store.getters["newGiftShoppingCart/storeGiftCards"].length != 0
        ) {
          var that = this;
          // setTimeout(() => that.sliderSetup(), 5000);
          this.$nextTick(() => {
            that.sliderSetup();
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    sliderSetup() {
      this.track = querySelector(".carousel__track");
      this.slides = Array.from(this.track.children);
      this.previewNav = querySelector(".carousel__nav");
      this.previews = Array.from(this.previewNav.children);

      //this.slideWidth = this.slides[0].getBoundingClientRect().width;
      this.slideWidth =
        this.$refs.carouselCards[0].getBoundingClientRect().width;
      this.leftButton = querySelector(".carousel__button--left");
      this.rightButton = querySelector(".carousel__button--right");

      // helper function for calculating the track move amount
      const setSlidePosition = (slide, index) => {
        this.baseLeft =
          querySelector(".carousel__track").getBoundingClientRect().width / 2 -
          this.slideWidth / 2;
        slide.style.left = this.baseLeft + this.slideWidth * index + "px";
      };
      // extract proxy result to an object
      const target_copy = Object.assign({}, this.slides);
      // convert object to an array
      const slides_array_result = Object.values(target_copy);

      slides_array_result.forEach(setSlidePosition);

      //based on the index set the current slide
      var totalSlideWidth = this.slideWidth * this.currentSlidIndex;
      this.track.style.transform = "translateX(-" + totalSlideWidth + "px)";

      if (this.currentSlidIndex == 0) {
        //nothing to do
      } else if (this.slides.length == this.currentSlidIndex + 1) {
        //the last one, hide right, show left
        this.leftButton.classList.remove("is-hidden");
        this.rightButton.classList.add("is-hidden");
      } else {
        this.leftButton.classList.remove("is-hidden");
      }
    },
    populateselected() {
      var that = this;
      this.$nextTick(() => {
        that.track = querySelector(".carousel__track");
        that.slides = Array.from(that.track.children);
        that.previewNav = querySelector(".carousel__nav");
        that.previews = Array.from(that.previewNav.children);

        var productIndex = that.validProducts.findIndex(
          (x) => x.ProductID == that.selectedGiftCardId
        );
        var product = that.validProducts[productIndex];
        const targetPreview = $$(".carousel__nav").find(
          '[data-giftid="' + product.ProductID + '"]'
        );
        //const targetPreview = $$(clickedElement).closest("button");

        if (!targetPreview) {
          return;
        }
        // extract proxy result to an object
        const target_copy = Object.assign({}, that.previews);
        // convert object to an array
        const previews_array_result = Object.values(target_copy);

        const slides_target_copy = Object.assign({}, that.slides);
        const slides_array_result = Object.values(slides_target_copy);

        const currentSlide = that.track.querySelector(".current-slide");
        const targetIndex = previews_array_result.findIndex(
          (preview) => preview === targetPreview[0]
        );
        const targetSlide = slides_array_result[targetIndex];

        that.moveToSlide(that.track, currentSlide, targetSlide);

        //that.hideShowArrows(slides_array_result, that.leftButton, that.rightButton, targetIndex);
        that.$emit("selecteditem", product);
      });
    },
    // helper function to calculate the amount to move
    moveToSlide(track, currentSlide, targetSlide) {
      track.style.transform = "translateX(-" + targetSlide.style.left + ")";
    },

    hideShowArrows(slides_array_result, leftButton, rightButton, targetIndex) {
      if (targetIndex === 0) {
        leftButton.classList.add("is-hidden");
        rightButton.classList.remove("is-hidden");
      } else if (targetIndex === slides_array_result.length - 1) {
        leftButton.classList.remove("is-hidden");
        rightButton.classList.add("is-hidden");
      } else {
        leftButton.classList.remove("is-hidden");
        rightButton.classList.remove("is-hidden");
      }
    },

    onCarouselBtnClick(position) {
      if (position === "left") {
        const currentSlide = this.track.querySelector(".current-slide");
        const prevSlide = currentSlide.previousElementSibling;
        const slides_target_copy = Object.assign({}, this.slides);
        const slides_array_result = Object.values(slides_target_copy);
        const prevIndex = slides_array_result.findIndex(
          (slide) => slide === prevSlide
        );
        this.moveToSlide(this.track, currentSlide, prevSlide);

        //this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, prevIndex);
        this.$emit("targetIndex", prevIndex);
        this.$emit("selecteditem", this.productsCurrent[prevIndex]);
      } else {
        const slides_target_copy = Object.assign({}, this.slides);
        const slides_array_result = Object.values(slides_target_copy);
        const currentSlide = this.track.querySelector(".current-slide");
        const nextSlide = currentSlide.nextElementSibling;
        const nextIndex = slides_array_result.findIndex(
          (slide) => slide === nextSlide
        );
        this.moveToSlide(this.track, currentSlide, nextSlide);

        //this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, nextIndex);
        this.$emit("targetIndex", nextIndex);
        this.$emit("selecteditem", this.productsCurrent[nextIndex]);
      }
    },

    onNavClick(e) {
      var clickedElement = e.target;
      const targetPreview = $$(clickedElement).closest("button");

      if (!targetPreview) {
        return;
      }
      // extract proxy result to an object
      const target_copy = Object.assign({}, this.previews);
      // convert object to an array
      const previews_array_result = Object.values(target_copy);

      const slides_target_copy = Object.assign({}, this.slides);
      const slides_array_result = Object.values(slides_target_copy);

      const currentSlide = this.track.querySelector(".current-slide");
      const targetIndex = previews_array_result.findIndex(
        (preview) => preview === targetPreview[0]
      );
      const targetSlide = slides_array_result[targetIndex];

      this.moveToSlide(this.track, currentSlide, targetSlide);

      //this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, targetIndex);
      this.$emit("targetIndex", targetIndex);
      this.$emit("selecteditem", this.validProducts[targetIndex]);
    },
    toggleCardVisible() {
      this.$emit("toggleCardVisible");
    },
  },
  created() {},
};
</script>

<style scoped>
.carousel__track-nav-container {
  height: 100%;
  margin: 0 auto;
  width: 68%;
}
.carousel__preview__image {
  height: 100%;
  width: 100%;
}
.carousel__preview__button {
  height: 100%;
  border: 0;
  background: transparent;
}
.current__preview {
  border: 2px solid #55a7ff;
  border-radius: 9px;
}
.carousel__nav {
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.carousel__nav > * {
  width: 100%;
  flex: 1;
  margin: 0 5px;
}
.carousel__preview__button:first-child {
  margin-left: 0;
}
.carousel__preview__button:last-child {
  margin-right: 0;
}
.carousel {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  width: 100%;
  flex: 0 0 auto;
}
.carousel__track-container {
  height: 80%;
  overflow: hidden;
  /* width: 68%; */
  min-width: 312px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.carousel-slide {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
.carousel__track {
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  list-style-type: none;
  transition: transform 250ms ease-in;
}
.carousel__button {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  background: transparent;
  border: 0;
  cursor: pointer;
}
.carousel__button:focus {
  outline: none;
}
.carousel__button--left {
  z-index: 1;
  left: 3%;
}
.carousel__button--right {
  right: 3%;
}
.carousel__button__image {
  width: 50%;
}
.carousel_hidden_btn {
  display: none;
}
@media only screen and (max-width: 900px) {
  .carousel__track-container {
    height: 75%;
  }
  .carousel__button--left {
    left: -8%;
  }
  .carousel__button--right {
    right: -8%;
  }
  .carousel__track-nav-container {
    width: 310px;
  }
}
@media only screen and (max-width: 600px) {
  .carousel__nav {
    width: 260px;
  }
  .carousel__button--left {
    left: -3%;
  }
  .carousel__button--right {
    right: -3%;
  }
}
</style>
